import { Box, Avatar, Typography, Stack } from '@mui/material'
import { IUserProfile } from '../../pages/UsersPage/constants'
import { IReport } from '../../store/reports/types'
import textUtils from '../../utils/textUtils'
import FormLayout from '../forms/FormLayout'
import TableTAG from '../TableTAG'

interface IPersonType {
  image: string
  full_name: string
  person_type: string
  id: number
}

const teamColumns = () => [
  {
    id: 'user.username',
    label: 'Name',
    format: (value: string, row: IUserProfile) => {
      return (
        <Box sx={{ display: 'flex', gap: '2rem', alignItems: 'center' }}>
          <Avatar />
          <Typography variant='bodyBold'>
            {row?.user.first_name} {row?.user.last_name}
          </Typography>
        </Box>
      )
    },
  },
  { id: 'title', label: 'Title' },
]

const renderSubjects = (subjects: IPersonType[]) => {
  return subjects.map(subject => (
    <Box
      sx={{ display: 'flex', marginBottom: '1.2rem', gap: '3.6rem' }}
      key={`subject-${subject.id}`}
    >
      <Box>
        <Box sx={{ width: '12rem', height: '12rem' }}>
          <img
            src={subject.image}
            style={{ objectFit: 'cover', width: '100%', height: '100%', borderRadius: '5px' }}
          />
        </Box>
      </Box>
      <Stack sx={{ gap: '1.8rem' }}>
        <Stack>
          <Typography variant='labelBold'> Subject Type</Typography>
          <Typography variant='bodyRegular'>{textUtils.humanize(subject?.person_type)}</Typography>
        </Stack>
        <Stack>
          <Typography variant='labelBold'> Full Name</Typography>
          <Typography variant='bodyRegular'>{subject?.full_name}</Typography>
        </Stack>
      </Stack>
    </Box>
  ))
}

const getOverviewContent = (name: string, report_status: string, tier_level: number) => {
  return (
    <>
      <Stack sx={{ gap: '1.8rem' }}>
        <Stack>
          <Typography variant='labelBold'> Case Name</Typography>
          <Typography variant='bodyRegular'>{name}</Typography>
        </Stack>
        <Stack>
          <Typography variant='labelBold'>Case Status</Typography>
          <Typography variant='bodyRegular'>{textUtils.humanize(report_status)}</Typography>
        </Stack>
        <Stack>
          <Typography variant='labelBold'>Tier Level</Typography>
          <Typography variant='bodyRegular'>{tier_level}</Typography>
        </Stack>
      </Stack>
    </>
  )
}

const getSections = (report: IReport, teamMembers?: IUserProfile[]) => {
  const { subjects, victims, reporters, name, report_status, tier_level } = report
  return [
    {
      title: 'Overview',
      body: getOverviewContent(name, report_status?.status, tier_level),
    },
    teamMembers
      ? {
          title: 'Team',
          body: (
            <FormLayout>
              <TableTAG columns={teamColumns()} pagination={false} rows={teamMembers} />
            </FormLayout>
          ),
        }
      : {},
    subjects.length
      ? {
          title: 'Subjects',
          body: renderSubjects(subjects),
        }
      : {},
    victims.length
      ? {
          title: 'Victims',
          body: renderSubjects(victims),
        }
      : {},
    reporters.length
      ? {
          title: 'Reporters',
          body: renderSubjects(reporters),
        }
      : {},
  ]
}

export default {
  teamColumns,
  getSections,
  renderSubjects,
  getOverviewContent,
}